/* eslint-disable max-len */
import React from 'react';
import { extend, pick, noop, defaults, isMatch, isEqual } from 'underscore';
import { withLayoutContext, Mode } from '@bingads-webui-react/app-layout-container';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { withHotKeys, ShortcutType } from '@bingads-webui-react/hot-keys';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import PropTypes from 'prop-types';
import { ToolbarContainer as ToolbarContainerBase } from '@bingads-webui-grid/toolbar-container';
import { withToggleChart } from './with-toggle-chart';
import { getGlobalStyles } from './global-styles';


const getStyles = (_, { palette = {}, semanticColors = {}, spacing = {} }) => extend({
}, getGlobalStyles({ palette, semanticColors, spacing }));

export const FullScreenWithTabConfig = {
  header: {
    mode: Mode.Hidden,
  },
  nav: {
    mode: Mode.Hidden,
  },
  status: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Hidden,
  },
  subTab: {
    mode: Mode.Hidden,
  },
  scopePanel: {
    mode: Mode.Hidden,
  },
};

const CopilotFullScreenWithTabConfig = {
  header: {
    mode: Mode.Hidden,
  },
  nav: {
    mode: Mode.Hidden,
  },
  status: {
    mode: Mode.Expanded,
    showCopilot: {
      right: 320,
    },
  },
  menu: {
    mode: Mode.Hidden,
  },
  subTab: {
    mode: Mode.Hidden,
    showCopilot: {
      right: 320,
    },
  },
};

export const isTableExpanded = (layoutConfig) => {
  const entries = Object.entries(layoutConfig);
  for (let i = 0; i < entries.length; i += 1) {
    const [key, config] = entries[i];

    if ((FullScreenWithTabConfig[key] != null && !isMatch(config, FullScreenWithTabConfig[key]))
      && (CopilotFullScreenWithTabConfig[key] != null && !isEqual(config, CopilotFullScreenWithTabConfig[key]))) {
      return false;
    }
  }
  return true;
};

export const getConfigComponents = config => ({
  ...pick(config, 'header', 'nav', 'status', 'menu', 'subTab', 'scopePanel'),
  menu: {
    mode: config.menu && config.menu.mode,
  },
});

class ToolbarContainerUINext extends React.Component {
  constructor(props) {
    super(props);

    this.floatingBannerId = '';
    this.originalChartState = false;
    this.originalConfig = this.getConfigComponents();
  }
  /* istanbul ignore next */
  componentDidUpdate(prevProps) {
    if (this.props.hotKey === 'escape' && prevProps.count !== this.props.count && this.isTableExpanded()) {
      this.toggleExpandTable();
    }
  }
  /* istanbul ignore next */
  componentWillUnmount() {
    if (this.isTableExpanded()) {
      notificationApi.dismiss(this.floatingBannerId);
    }
  }
  getConfigComponents = () => getConfigComponents(this.props.layoutConfig);

  isTableExpanded = () => isTableExpanded(this.getConfigComponents());

  toggleExpandTable = () => {
    if (this.isTableExpanded()) {
    /* istanbul ignore next */
      this.props.changeLayout(defaults({}, this.originalConfig, { topBanner: { mode: Mode.Collapsed } }, this.props.layoutConfig), true);
      /* istanbul ignore next */

      this.props.restoreChart(this.originalChartState);
      /* istanbul ignore next */

      notificationApi.dismiss(this.floatingBannerId);
    } else {
      this.originalConfig = this.getConfigComponents();
      this.props.changeLayout(defaults({}, FullScreenWithTabConfig, { topBanner: { mode: Mode.Hidden } }, this.props.layoutConfig), true);

      this.originalChartState = this.props.hideChart();

      this.floatingBannerId = notificationApi.showInfo(this.props.i18n.getString(_TL_('Press Esc key to exit full screen')));
    }
  };


  render() {
    return (
      <ToolbarContainerBase {...this.props} toggleExpandTable={() => this.toggleExpandTable()} isTableExpandedFlag={this.isTableExpanded()} />
    );
  }
}

ToolbarContainerUINext.propTypes = {
  forceHideToolbar: PropTypes.bool.isRequired,
  showToolbarSelected: PropTypes.bool.isRequired,
  showToolbarUnselected: PropTypes.bool.isRequired,
  toolbarSelectedConfig: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  toolbarUnselectedConfig: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  onClear: PropTypes.func.isRequired,
  selectionCount: PropTypes.number,
  totalCount: PropTypes.number,
  isCrossPageAllSelected: PropTypes.bool,
  isSinglePageAllSelected: PropTypes.bool,
  isMultiPage: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }),
  onDataDidRender: PropTypes.func,
  layoutConfig: PropTypes.shape({}).isRequired,
  changeLayout: PropTypes.func.isRequired,
  hideChart: PropTypes.func.isRequired,
  restoreChart: PropTypes.func.isRequired,
  hotKey: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

ToolbarContainerUINext.defaultProps = {
  selectionCount: 0,
  totalCount: 0,
  isCrossPageAllSelected: false,
  isSinglePageAllSelected: false,
  isMultiPage: false,
  i18n: null,
  onDataDidRender: noop,
  toolbarSelectedConfig: new Map(),
  toolbarUnselectedConfig: undefined,
};

// TODO: merge theme with styles in the callback
export const ToolbarContainer = withHotKeys(withToggleChart(withLayoutContext(withDefaultStyles(ToolbarContainerUINext, getStyles))), ShortcutType.CollapseTable);
